/* Only selects the currently displayed variant; saving requires confirmation in the account. */
(()=>{'use strict';
 document.addEventListener('click',event=>{
  const link=event.target instanceof Element?event.target.closest('a[data-p040-wishlist-form]'):null;
  if(!link)return;
  const form=document.getElementById(link.dataset.p040WishlistForm);
  const input=form?.querySelector('[name="id"]');
  const id=input?.value;
  if(!id||!/^\d+$/.test(id)||!Number.isSafeInteger(Number(id))||Number(id)<=0){event.preventDefault();form?.scrollIntoView({block:'center'});return;}
  const destination=new URL(link.dataset.p040WishlistBase);
  if(destination.origin!=='https://shopify.com') {event.preventDefault();return;}
  destination.searchParams.set('p040_merken',id);link.href=destination.href;
 });
})();
